import { FormGroup, FormBuilder, Validators, FormArray } from '@angular/forms';
import { Component, ViewChild, Output, EventEmitter, ElementRef, Input } from '@angular/core';
import { NavController, NavParams, ModalController, ToastController, Slides, ViewController, AlertController, MenuController, App } from 'ionic-angular';
import { AngularFirestore, AngularFirestoreDocument } from 'angularfire2/firestore';
import * as $ from 'jquery';
import firebase from 'firebase/app';
import { AngularFireAuth } from 'angularfire2/auth';
import { Http, Headers, RequestOptions } from '@angular/http';
import { LoadingProvider } from '../../../../../providers/loading/loading';
import createAutoCorrectedDatePipe from 'text-mask-addons/dist/createAutoCorrectedDatePipe';
import createNumberMask from 'text-mask-addons/dist/createNumberMask';
import { ViewContactPage } from '../../../../view-contact/view-contact';
import { HomePage } from '../../../../home/home';
import { SdfFormService } from '../../../../../app/services/sdf-form-service';
//import { post } from 'jquery';
import { AngularFireStorage } from 'angularfire2/storage';
import { fromEvent, from } from 'rxjs';
import { debounceTime, take } from "rxjs/operators";
import { EnvDataService } from '../../../../../app/services/env-data-service';

declare var google;
@Component({
  selector: 'adf-employment-details-form',
  templateUrl: 'employment_details.html',
  providers: [EnvDataService]
})
export class EmploymentDetails {
  @Input() editdata: any;
  @Output() valueChange = new EventEmitter();
  @Output() incomeChange = new EventEmitter();
  slideThreeForm: FormGroup;

  userRole: any;
  new_val: any;
  old_val: any;
  applicant_details: any;
  allBrokers: any;
  applicant_type: any;
  dateMask = [/\d/, /\d/, '/', /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/];
  SDF_form_document_id: any;
  primary_uid: any;
  edit_contact_uid: any;
  deleted_access: any;
  firstname1: any;
  public change_log_string: any;
  public employementType;
  public isCurrentEmployeed;
  public isemployementType;
  public expectedWork;
  public statusEmployment;
  public new_uid;
  public employment_details: any;
  public indexx: number;
  public showPrimaryApplicantEmployement: number = 1;
  public showAdditional_employement: number = -1;

  public currentdatestatus = true;

  public validation_messages = {
    'employementType': [
      { type: 'required', message: 'Employment type required.' }
    ],
    'currentlyEmployment': [
      { type: 'required', message: 'Current employment required.' }
    ],
    'expectFindWork': [
      { type: 'required', message: 'Enter expect find work.' }
    ],
    'statusyourEmployment': [
      { type: 'required', message: 'Status your employment required.' }
    ],
    'your_occupation': [
      { type: 'required', message: 'Your occupation required.' }
    ],
    'start_date': [
      { type: 'required', message: 'When did you start in this role required.' }
    ],
    'business_name': [
      { type: 'required', message: 'Business name required.' }
    ],
    'nature_of_business': [
      { type: 'required', message: 'Nature of business required.' }
    ],

  }

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    public formBuilder: FormBuilder,
    public db: AngularFirestore,
  ) {
    this.userRole = window.localStorage.getItem("userRole");
    this.applicant_details = '';
    this.getAllBrokers().subscribe((data) => {
      this.allBrokers = data;
    });
    this.applicant_type = "Primary";
    this.SDF_form_document_id = this.navParams.get("SDF_form_document_id");
    let thiss = this;
    this.change_log_string = [];

    this.slideThreeForm = formBuilder.group({
      // employementType: ['', Validators.required],
      // currentlyEmployment: ['', Validators.required],
      // expectFindWork: ['', Validators.required],
      // statusyourEmployment: ['', Validators.required],
      // your_occupation: ['', Validators.required],
      // start_date: ['', Validators.required],
      // business_name: ['', Validators.required],
      // type_of_entity: [''],
      // abn_acn: [''],
      // nature_of_business: ['', Validators.required],
      // addEmploymentItem: this.formBuilder.array([]),
      // addPrimaryEmploymentItem: this.formBuilder.array([])
      employementType: ['', Validators.required],
      currentlyEmployment: ['', Validators.required],
      expectFindWork: [''],
      statusyourEmployment: ['', Validators.required],
      your_occupation: ['', Validators.required],
      start_date: ['', Validators.required],
      business_name: ['', Validators.required],
      type_of_entity: [''],
      abn_acn: [''],
      nature_of_business: ['',Validators.required],
      addEmploymentItem: this.formBuilder.array([]),
      addPrimaryEmploymentItem: this.formBuilder.array([])
    });


  }


  initaddAnotherApplicantEmployment2(formObj) {
    // return this.formBuilder.group({

    //   employementType: [formObj.employementType,[Validators.required]],
    //   currentlyEmployment: ['No',[Validators.required]],
    //   statusyourEmployment: [formObj.statusyourEmployment,[Validators.required]],
    //   your_occupation: [formObj.your_occupation,[Validators.required]],
    //   start_date: [formObj.start_date,[Validators.required]],
    //   expectFindWork: [formObj.expectFindWork],
    //   business_name: [formObj.business_name],
    //   type_of_entity: [formObj.type_of_entity],
    //   abn_acn: [formObj.abn_acn],
    //   nature_of_business: [formObj.nature_of_business],
    //   deleted: [0],
    //   previousEmploymentItem: this.formBuilder.array([])
    // });
    return this.formBuilder.group({

      employementType: [formObj.employementType,[Validators.required]],
      currentlyEmployment: ['No',[Validators.required]],
      statusyourEmployment: [formObj.statusyourEmployment,[Validators.required]],
      your_occupation: [formObj.your_occupation,[Validators.required]],
      start_date: [formObj.start_date,[Validators.required]],
      expectFindWork: [formObj.expectFindWork],
      business_name: [formObj.business_name],
      type_of_entity: [formObj.type_of_entity],
      abn_acn: [formObj.abn_acn],
      nature_of_business: [formObj.nature_of_business],
      deleted: [0],
      previousEmploymentItem: this.formBuilder.array([])
    });
  }
  ngOnInit() {
    console.log('abc', this.editdata); // object here
    if (this.editdata.contact_details != undefined) {
      if (this.editdata.contact_details.employment_details != undefined&&this.editdata.contact_details.employment_details.employementType!="") {
        var uData = this.editdata.contact_details.employment_details;
        this.employment_details=this.editdata.contact_details.employment_details;

        this.slideThreeForm.controls.employementType.setValue(uData.employementType);
        this.slideThreeForm.controls.currentlyEmployment.setValue(uData.currentlyEmployment);
        this.slideThreeForm.controls.expectFindWork.setValue(uData.expectFindWork);
        this.slideThreeForm.controls.statusyourEmployment.setValue(uData.statusyourEmployment);
        this.slideThreeForm.controls.your_occupation.setValue(uData.your_occupation);
        this.slideThreeForm.controls.start_date.setValue(uData.start_date);
        this.slideThreeForm.controls.business_name.setValue(uData.business_name);
        this.slideThreeForm.controls.type_of_entity.setValue(uData.type_of_entity);
        this.slideThreeForm.controls.abn_acn.setValue(uData.abn_acn);
        this.slideThreeForm.controls.nature_of_business.setValue(uData.nature_of_business);
        this.changeEmploymentType(uData.employementType, 'employementType');
        if (uData.employementType == 'payg') {
          this.currentEmployeed(uData.currentlyEmployment, 'currentlyEmployment');
        }
        this.slideThreeForm.controls.currentlyEmployment.setValue(uData.currentlyEmployment);
        this.slideThreeForm.controls.currentlyEmployment.setValidators(Validators.required);

        if(this.employment_details.addPrimaryEmploymentItem) {
          if(this.employment_details.addPrimaryEmploymentItem.length > 0 ) {

            this.employment_details.addPrimaryEmploymentItem.forEach((element,index) => {
              console.log(element);

              this.formPrimaryEmployment.push(this.initaddAnotherApplicantEmployment2(element));
              // let gcurrentlyEmployment = this.slideThreeForm.controls.addPrimaryEmploymentItem['controls'][index].get('currentlyEmployment');
              if(element.employementType == 'unemployed') {
                this.formPrimaryEmployment.at(index).get('start_date').clearValidators();
                this.formPrimaryEmployment.at(index).get('start_date').updateValueAndValidity();

                this.formPrimaryEmployment.at(index).get('statusyourEmployment').clearValidators();
                this.formPrimaryEmployment.at(index).get('statusyourEmployment').updateValueAndValidity();

                this.formPrimaryEmployment.at(index).get('your_occupation').clearValidators();
                this.formPrimaryEmployment.at(index).get('your_occupation').updateValueAndValidity();

              }
              // this.formPrimaryEmployment.at(index).get('start_date').clearValidators();
              // this.formPrimaryEmployment.at(index).get('start_date').updateValueAndValidity();
              // gcurrentlyEmployment.setErrors(null);
              // gcurrentlyEmployment.clearValidators();
              // gcurrentlyEmployment.updateValueAndValidity();
            });

          }
        }

        console.log(this.formPrimaryEmployment);
        console.log(this.slideThreeForm);

        //this.previousEmploymentItem.push(this.initaddAnotherApplicantEmployment(this.editdata.contact_details.address[i]));
      }

    }
  }
  ngOnChanges() {
    // console.log('abc', this.editdata); // object here
    // if (this.editdata.contact_details != undefined) {
    //   if (this.editdata.contact_details.employment_details != undefined&&this.editdata.contact_details.employment_details.employementType!="") {
    //     var uData = this.editdata.contact_details.employment_details;
    //     this.employment_details=this.editdata.contact_details.employment_details;

    //     this.slideThreeForm.controls.employementType.setValue(uData.employementType);
    //     this.slideThreeForm.controls.currentlyEmployment.setValue(uData.currentlyEmployment);
    //     this.slideThreeForm.controls.expectFindWork.setValue(uData.expectFindWork);
    //     this.slideThreeForm.controls.statusyourEmployment.setValue(uData.statusyourEmployment);
    //     this.slideThreeForm.controls.your_occupation.setValue(uData.your_occupation);
    //     this.slideThreeForm.controls.start_date.setValue(uData.start_date);
    //     this.slideThreeForm.controls.business_name.setValue(uData.business_name);
    //     this.slideThreeForm.controls.type_of_entity.setValue(uData.type_of_entity);
    //     this.slideThreeForm.controls.abn_acn.setValue(uData.abn_acn);
    //     this.slideThreeForm.controls.nature_of_business.setValue(uData.nature_of_business);
    //     this.changeEmploymentType(uData.employementType, 'employementType');
    //     if (uData.employementType == 'payg') {
    //       this.currentEmployeed(uData.currentlyEmployment, 'currentlyEmployment');
    //     }

    //     if(this.employment_details.addPrimaryEmploymentItem) {
    //       if(this.employment_details.addPrimaryEmploymentItem.length > 0 ) {

    //         this.employment_details.addPrimaryEmploymentItem.forEach((element,index) => {
    //           console.log(element);
    //           this.formPrimaryEmployment.push(this.initaddAnotherApplicantEmployment2(element));
    //           let gcurrentlyEmployment = this.slideThreeForm.controls.addPrimaryEmploymentItem['controls'][index].get('currentlyEmployment');
    //           gcurrentlyEmployment.setValidators(null);
    //         });

    //       }
    //     }

    //     //this.previousEmploymentItem.push(this.initaddAnotherApplicantEmployment(this.editdata.contact_details.address[i]));
    //   }

    // }


  }

  addAnotherApplicant() {
    this.formApplicantEmployment.push(this.initaddAnotherApplicantEmployment());
  }

  initaddAnotherApplicantEmployment() {
    return this.formBuilder.group({
      // list all your form controls here, which belongs to your form array
      employementType: ['', Validators.compose([Validators.maxLength(30), Validators.required])],
      currentlyEmployment: ['', Validators.compose([Validators.maxLength(30)])],
      statusyourEmployment: ['', Validators.compose([Validators.maxLength(30), Validators.required])],
      your_occupation: ['', Validators.compose([Validators.maxLength(30), Validators.required])],
      start_date: ['', Validators.compose([Validators.maxLength(30), Validators.required])],
      expectFindWork: ['', Validators.compose([Validators.maxLength(30), Validators.required])],
      business_name: ['', Validators.compose([Validators.maxLength(30), Validators.required])],
      type_of_entity: [''],
      abn_acn: ['', Validators.compose([Validators.maxLength(30)])],
      nature_of_business: ['', Validators.compose([Validators.maxLength(30)])],
      deleted: [0],
      previousEmploymentItem: this.formBuilder.array([])
    });
  }

  editgetSDFUser(SDF_form_document_id, uid) {
    if (this.userRole == "super_admin" && this.deleted_access == 1) {
      return this.db.collection<any>("users_data", ref => ref.where('created_date', '>', 0).where('SDF_form_document_id', '==', SDF_form_document_id).where('uid', '==', uid).orderBy('created_date', 'asc')).valueChanges();
    } else {
      return this.db.collection<any>("users_data", ref => ref.where('created_date', '>', 0).where('SDF_form_document_id', '==', SDF_form_document_id).where('uid', '==', uid).where('deleted', '==', 0).orderBy('created_date', 'asc')).valueChanges();
    }
  }

  getAllBrokers() {
    return this.db.collection<any>("users", ref => ref.where('roles.broker', '==', true)).valueChanges();
  }

  //employment section
  get formPrimaryEmployment() {
    return this.slideThreeForm.get('addPrimaryEmploymentItem') as FormArray;
  }
  //employment section
  get formApplicantEmployment() {
    return this.slideThreeForm.get('addEmploymentItem') as FormArray;
  }



  changeLog(event, index: any) {
    // let this = this;
    // var property = event.ngControl.name;
    // this.new_val = event._value;
    // this.old_val = '';
    // var new_property = '';

    // if(index == 'main'){
    //   if(property == 'firstname'){
    //     this.old_val = (this.applicant_details.firstname == undefined) ? '' : this.applicant_details.firstname;
    //     new_property = 'Firstname';
    //     this.firstname = this.new_val;
    //   }
    //   if(property == 'middlename'){
    //     this.old_val = (this.applicant_details.middlename == undefined) ? '' : this.applicant_details.middlename;
    //     new_property = 'Middlename';
    //   }
    //   if(property == 'lastname'){
    //     this.old_val = (this.applicant_details.lastname == undefined) ? '' : this.applicant_details.lastname;
    //     new_property = 'Lastname';
    //     this.lastname = this.new_val;
    //   }
    //   if(property == 'email'){
    //     this.old_val = (this.applicant_details.email == undefined) ? '' : this.applicant_details.email;
    //     new_property = 'Email';
    //     this.checkContact = 0;
    //     firebase.firestore().collection("users").where("email", "==", this.new_val).get()
    //     .then(function(querySnapshot) {
    //       querySnapshot.forEach(function(priCon) {
    //         if(priCon.data().roles.contact == true){
    //           this.checkContact = 0;
    //         }else{
    //           this.checkContact = 1;
    //         }
    //       })
    //     })
    //     this.signupSlider.resize();
    //     this.signupSlider.update();
    //   }
    //   if(property == 'mobile_phone'){
    //     this.old_val = (this.applicant_details.mobile_phone == undefined) ? '' : this.applicant_details.mobile_phone;
    //     new_property = 'Mobile Phone';
    //   }
    //   if(property == 'primayr_goal_intention'){
    //     this.old_val = (this.applicant_details.primayr_goal_intention == undefined) ? '' : this.applicant_details.primayr_goal_intention;
    //     new_property = 'Primary Goal Intention';
    //   }
    //   if(property == 'floor_number'){
    //     this.old_val = (this.applicant_details.floor_number == undefined) ? '' : this.applicant_details.floor_number;
    //     new_property = 'Floor Number';
    //   }
    //   if(property == 'unit_number'){
    //     this.old_val = (this.applicant_details.unit_number == undefined) ? '' : this.applicant_details.unit_number;
    //     new_property = 'Unit Number';
    //   }
    //   if(property == 'building_name'){
    //     this.old_val = (this.applicant_details.building_name == undefined) ? '' : this.applicant_details.building_name;
    //     new_property = 'Building Name';
    //   }
    //   if(property == 'street_number'){
    //     this.old_val = (this.applicant_details.street_number == undefined) ? '' : this.applicant_details.street_number;
    //     new_property = 'Street Number';
    //   }
    //   if(property == 'street_name'){
    //     this.old_val = (this.applicant_details.street_name == undefined) ? '' : this.applicant_details.street_name;
    //     new_property = 'Street Name';
    //   }
    //   if(property == 'city'){
    //     this.old_val = (this.applicant_details.city == undefined) ? '' : this.applicant_details.city;
    //     new_property = 'City';
    //   }
    //   if(property == 'postcode'){
    //     this.old_val = (this.applicant_details.postcode == undefined) ? '' : this.applicant_details.postcode;
    //     new_property = 'Postcode';
    //   }
    //   if(property == 'poboxlabel'){
    //     this.old_val = (this.applicant_details.poboxlabel == undefined) ? '' : this.applicant_details.poboxlabel;
    //     new_property = 'PO Box Label';
    //   }
    //   if(property == 'first_child_age'){
    //     this.old_val = (this.applicant_details.first_child_age == undefined) ? '' : this.applicant_details.first_child_age;
    //     new_property = 'First Child Age';
    //   }
    //   if(property == 'second_child_age'){
    //     this.old_val = (this.applicant_details.second_child_age == undefined) ? '' : this.applicant_details.second_child_age;
    //     new_property = 'Second Child Age';
    //   }
    //   if(property == 'third_child_age'){
    //     this.old_val = (this.applicant_details.third_child_age == undefined) ? '' : this.applicant_details.third_child_age;
    //     new_property = 'Third Child Age';
    //   }
    //   if(property == 'fourth_child_age'){
    //     this.old_val = (this.applicant_details.fourth_child_age == undefined) ? '' : this.applicant_details.fourth_child_age;
    //     new_property = 'Fourth Child Age';
    //   }
    //   if(property == 'fifth_child_age'){
    //     this.old_val = (this.applicant_details.fifth_child_age == undefined) ? '' : this.applicant_details.fifth_child_age;
    //     new_property = 'Fifth Child Age';
    //   }
    //   if(property == 'sixth_child_age'){
    //     this.old_val = (this.applicant_details.sixth_child_age == undefined) ? '' : this.applicant_details.sixth_child_age;
    //     new_property = 'Sixth Child Age';
    //   }
    //   if(property == 'your_occupation'){
    //     this.old_val = (this.employment_details.your_occupation == undefined) ? '' : this.employment_details.your_occupation;
    //     new_property = 'Your Occupation';
    //   }
    //   if(property == 'start_date'){
    //     this.old_val = (this.employment_details.start_date == undefined) ? '' : this.employment_details.start_date;
    //     new_property = 'Employment start date';
    //   }
    //   if(property == 'business_name'){
    //     this.old_val = (this.employment_details.business_name == undefined) ? '' : this.employment_details.business_name;
    //     new_property = 'Business Name';
    //   }
    //   if(property == 'type_of_entity'){
    //     this.old_val = (this.employment_details.type_of_entity == undefined) ? '' : this.employment_details.type_of_entity;
    //     new_property = 'Type of Entity';
    //   }
    //   if(property == 'abn_acn'){
    //     this.old_val = (this.employment_details.abn_acn == undefined) ? '' : this.employment_details.abn_acn;
    //     new_property = 'abn_acn';
    //   }
    //   if(property == 'nature_of_business'){
    //     this.old_val = (this.employment_details.nature_of_business == undefined) ? '' : this.employment_details.nature_of_business;
    //     new_property = 'Nature of Business';
    //   }
    // }else{
    //   if(property == 'secondary_email'){
    //     this.old_val = (this.secondary_details.secondary_email == undefined) ? '' : this.secondary_details.secondary_email;
    //     new_property = 'Email';
    //     this.checkAddiContact.push({'status': 0});
    //     this.checkAddiContact[index].status = 0;
    //     this.checkAddiContactStatus = 0;
    //     firebase.firestore().collection("users").where("email", "==", this.new_val).get()
    //     .then(function(querySnapshot) {
    //       querySnapshot.forEach(function(priCon) {
    //         if(priCon.data().roles.contact == true){
    //           this.checkAddiContact[index].status = 0;
    //         }else{
    //           this.checkAddiContact[index].status = 1;
    //           this.checkAddiContactStatus = 1;
    //         }
    //       })
    //     })
    //     this.signupSlider.resize();
    //     this.signupSlider.update();
    //   }

    // }



    // if(this.new_val != this.old_val){
    //   //this.change_log_string += property+'='+this.old_val+':'+this.new_val+';';
    //   this.change_log_string.push({'property' : new_property, 'old_value' : this.old_val, 'new_value' : this.new_val, 'index': index, 'index2': index});
    // }
  }
  collectLogData(event, type, index) {
    this.new_val = event.target.value;
    this.old_val = '';
    var property = '';
    if (type == 'address_type') {
      this.old_val = (this.applicant_details.address_type == undefined) ? '' : this.applicant_details.address_type;
      property = 'Address Type';
    }
    if (type == 'street_type') {
      this.old_val = (this.applicant_details.street_type == undefined) ? '' : this.applicant_details.street_type;
      property = 'Street Type';
    }
    if (type == 'state') {
      this.old_val = (this.applicant_details.state == undefined) ? '' : this.applicant_details.state;
      property = 'State';
    }
    if (type == 'country') {
      this.old_val = (this.applicant_details.country == undefined) ? '' : this.applicant_details.country;
      property = 'Country';
    }
    if (type == 'housing_situation') {
      this.old_val = (this.applicant_details.housing_situation == undefined) ? '' : this.applicant_details.housing_situation;
      property = 'Housing Situation';
    }
    if (type == 'move_in_date') {
      this.old_val = (this.applicant_details.move_in_date == undefined) ? '' : this.applicant_details.move_in_date;
      property = 'Move in Date';
    }
    if (type == 'date_of_birth') {
      this.old_val = (this.applicant_details.date_of_birth == undefined) ? '' : this.applicant_details.date_of_birth;
      property = 'Date of Birth';
    }
    if (this.new_val != this.old_val) {
      this.change_log_string.push({ 'property': property, 'old_value': this.old_val, 'new_value': this.new_val, 'index': index, 'index2': index });
    }
    console.log('this.change_log_string', this.change_log_string)
  }

  public changeEmploymentType($event, type) {
    debugger;
    console.log(this.slideThreeForm);
    let gcurrentlyEmployment = this.slideThreeForm.get('currentlyEmployment');
    let gexpectFindWork = this.slideThreeForm.get('expectFindWork');
    let gstatusyourEmployment = this.slideThreeForm.get('statusyourEmployment');
    let gyour_occupation = this.slideThreeForm.get('your_occupation');
    let gstart_date = this.slideThreeForm.get('start_date');
    let gbusiness_name = this.slideThreeForm.get('business_name');
    let gnature_of_business = this.slideThreeForm.get('nature_of_business');
    if ($event == 'payg') {
      this.employementType = $event;
      gbusiness_name.setValidators(null);
      gnature_of_business.setValidators(null);
      gcurrentlyEmployment.setValue('');
      gcurrentlyEmployment.setValidators(Validators.required);
      gstart_date.setValidators(Validators.required);
      if(this.employment_details) {
        if(this.employment_details.employementType == 'self-employed'){
          this.new_val = '';
          this.old_val = this.employment_details.business_name;
          property = 'Business Name';
          if(this.new_val != this.old_val){
            this.change_log_string.push({'property' : property, 'old_value' : this.old_val, 'new_value' : this.new_val, 'index': 0, 'index2': 'main'});
          }
          this.old_val = this.employment_details.type_of_entity;
          property = 'Type of Entity';
          if(this.new_val != this.old_val){
            this.change_log_string.push({'property' : property, 'old_value' : this.old_val, 'new_value' : this.new_val, 'index': 0, 'index2': 'main'});
          }
          this.old_val = this.employment_details.abn_acn;
          property = 'ABN/ACN';
          if(this.new_val != this.old_val){
            this.change_log_string.push({'property' : property, 'old_value' : this.old_val, 'new_value' : this.new_val, 'index': 0, 'index2': 'main'});
          }
          this.old_val = this.employment_details.nature_of_business;
          property = 'Nature of Business';
          if(this.new_val != this.old_val){
            this.change_log_string.push({'property' : property, 'old_value' : this.old_val, 'new_value' : this.new_val, 'index': 0, 'index2': 'main'});
          }
        }
      }

    } else {

      this.employementType = $event;
      gcurrentlyEmployment.clearValidators();
      //gcurrentlyEmployment.updateValueAndValidity();
      gexpectFindWork.clearValidators();
     // gexpectFindWork.updateValueAndValidity();
      gstatusyourEmployment.clearValidators();
     // gstatusyourEmployment.updateValueAndValidity();
      gyour_occupation.clearValidators();
      //gyour_occupation.updateValueAndValidity();
      gstart_date.clearValidators();
     // gstart_date.updateValueAndValidity();
      gstart_date.setValue(null);
      gbusiness_name.setValidators(Validators.required);
      gnature_of_business.setValidators(Validators.required);
      this.removeAllPreviousEmployment();
       if(this.employment_details) {
        if (this.employment_details.employementType == 'payg') {
          this.new_val = '';
          this.old_val = this.employment_details.currentlyEmployment;
          property = 'Currently Employment';
          if (this.new_val != this.old_val) {
            this.change_log_string.push({ 'property': property, 'old_value': this.old_val, 'new_value': this.new_val, 'index': 0, 'index2': 'main' });
          }
          this.old_val = (this.employment_details.statusyouredEmployment == undefined) ? '' : this.employment_details.statusyouredEmployment;
          property = 'What is the status of your employment?';
          if (this.new_val != this.old_val) {
            this.change_log_string.push({ 'property': property, 'old_value': this.old_val, 'new_value': this.new_val, 'index': 0, 'index2': 'main' });
          }
          this.old_val = this.employment_details.your_occupation;
          property = 'Your Occupation';
          if (this.new_val != this.old_val) {
            this.change_log_string.push({ 'property': property, 'old_value': this.old_val, 'new_value': this.new_val, 'index': 0, 'index2': 'main' });
          }
          this.old_val = this.employment_details.start_date;
          property = 'Employment role date';
          if (this.new_val != this.old_val) {
            this.change_log_string.push({ 'property': property, 'old_value': this.old_val, 'new_value': this.new_val, 'index': 0, 'index2': 'main' });
          }
          this.old_val = this.employment_details.expectFindWork;
          property = 'In how long do you expect to find work?';
          if (this.new_val != this.old_val) {
            this.change_log_string.push({ 'property': property, 'old_value': this.old_val, 'new_value': this.new_val, 'index': 0, 'index2': 'main' });
          }
        }
       }

    }
    gcurrentlyEmployment.updateValueAndValidity();
    gexpectFindWork.updateValueAndValidity();
    gstatusyourEmployment.updateValueAndValidity();
    gyour_occupation.updateValueAndValidity();
    gstart_date.updateValueAndValidity();
    gbusiness_name.updateValueAndValidity();
    gnature_of_business.updateValueAndValidity();
    // this.signupSlider.resize();
    // this.signupSlider.update();

    this.new_val = $event;
    this.old_val = '';
    var property = '';
    // if(type == 'employementType'){
    //   this.old_val = (this.employment_details.employementType == undefined) ? '' : this.employment_details.employementType;
    //   property = 'Employement Type';
    // }

    if(type == 'employementType'){

      if(this.employment_details) {
        this.old_val = (this.employment_details.employementType == undefined) ? '' : this.employment_details.employementType;
        property = 'Employement Type';
      }

    }
    if (this.new_val != this.old_val) {
      this.change_log_string.push({ 'property': property, 'old_value': this.old_val, 'new_value': this.new_val, 'index': 0, 'index2': 'main' });
    }
  }

  public currentEmployeed(value, type) {
    debugger;
    let gexpectFindWork = this.slideThreeForm.get('expectFindWork');
    let gstatusyourEmployment = this.slideThreeForm.get('statusyourEmployment');
    let gyour_occupation = this.slideThreeForm.get('your_occupation');
    let gstart_date = this.slideThreeForm.get('start_date');
    let gbusiness_name = this.slideThreeForm.get('business_name');
    let gnature_of_business = this.slideThreeForm.get('nature_of_business');
    if (value == 'yes') {
      this.isCurrentEmployeed = value;
      gstatusyourEmployment.setValidators(Validators.required);
      gyour_occupation.setValidators(Validators.required);
      gstart_date.setValidators(Validators.required);
      gexpectFindWork.setValidators(null);
      this.incomeChange.emit('yes');

    } else {
      this.isCurrentEmployeed = value;
      gexpectFindWork.setValidators(Validators.required);
      gstatusyourEmployment.setValidators(null);
      gyour_occupation.setValidators(null);
      gstart_date.setValidators(null);
      this.incomeChange.emit('no');
    }
    gbusiness_name.setValidators(null);
    gnature_of_business.setValidators(null);

    gexpectFindWork.updateValueAndValidity();
    gstatusyourEmployment.updateValueAndValidity();
    gyour_occupation.updateValueAndValidity();
    gstart_date.updateValueAndValidity();
    gbusiness_name.updateValueAndValidity();
    gnature_of_business.updateValueAndValidity();
    //this.signupSlider.resize();
    //this.signupSlider.update();
    //change log data
    this.new_val = value;
    this.old_val = '';
    var property = '';
    // if(type == 'currentlyEmployment'){
    //   this.old_val = (this.employment_details.currentlyEmployment == undefined) ? '' : this.employment_details.currentlyEmployment;
    //   property = 'Currently Employment';
    // }
    if (this.new_val != this.old_val) {
      //this.change_log_string += type+'='+this.old_val+':'+this.new_val+';';
      this.change_log_string.push({ 'property': property, 'old_value': this.old_val, 'new_value': this.new_val });
    }
  }

  public statusyouredEmployment(value, type, index) {
    if (value == 'other') {
      this.statusEmployment = 'other';
    } else {
      this.statusEmployment = '';
    }
    //this.signupSlider.resize();
    //this.signupSlider.update();
    this.new_val = value;
    this.old_val = '';
    var property = '';
    if (index == 'main') {
      if (type == 'statusyourEmployment') {
        this.old_val = (this.applicant_details.statusyourEmployment == undefined) ? '' : this.applicant_details.statusyourEmployment;
        property = 'Status Your Employment';
      }
    }
    if (this.new_val != this.old_val) {
      //this.change_log_string += type+'='+this.old_val+':'+this.new_val+';';
      this.change_log_string.push({ 'property': property, 'old_value': this.old_val, 'new_value': this.new_val, 'index': index, 'index2': index });
    }
  }

  getRoleStartDate(event, key, con_type, index: 0) {

    debugger;
    var getDate = event.target.value;
    if(this.currentdatestatus) {
      this.valueChange.emit(getDate);
      this.currentdatestatus = false;
    }

    var datesplit = getDate.split("/");
    if (datesplit.length == 3) {
      var newDate = new Date().getTime()
      var oldDate = new Date(datesplit[2] + '-' + datesplit[1] + '-' + datesplit[0] + 'T00:00:00Z')
     // console.log(newDate_1.getFullYear())
        //oldDate.setMonth(oldDate.getMonth() + 36);
        oldDate.setFullYear(oldDate.getFullYear() + 3)

        var newDate_1 = new Date();
      if(oldDate.getFullYear() < newDate_1.getFullYear()) {
        if(key == 'main') {
          this.removeAllPreviousEmployment()
        }
        else {
          this.removePreviousEmployment(key)
        }

      }
      else {



        var oldDate1 = oldDate.getTime();
        if (con_type == 'primary') {
          debugger
          if (newDate > oldDate1) {
            // if(this.formPrimaryEmployment.length <= 2 ){
            //     this.removePreviousEmployment(key)
            // }

            this.removePreviousEmployment(key)

            //this.signupSlider.resize();
            //this.signupSlider.update();
          } else {

            if ((this.formPrimaryEmployment.length == 1 && key == "main")) {
            }
            else {
              if (this.formPrimaryEmployment.length == (key + 1)) {
                this.addPreviousEmployment()
              } else if ((this.formPrimaryEmployment.length == 0 && key == "main")) {
                this.addPreviousEmployment()
              }
            }

            // if(this.formPrimaryEmployment.length <= 2 ){
            //   this.addPreviousEmployment()

            // }
            // if((this.formApplicantEmployment.length == 1 && key == "main")){

            // }else{
            //   if(this.formApplicantEmployment.length == (key + 1)){
            //     this.addPreviousEmployment();
            //   }else if((this.formApplicantEmployment.length == 0 && key == "main")){
            //     this.addPreviousEmployment();
            //   }
            // }

          }

        } else if (con_type == 'additional') {

          if (newDate > oldDate1) {
            //this.removePreviousEmployment(key);
            this.formApplicantEmployment.controls[index]['controls'].previousEmploymentItem.removeAt(key);
            //this.signupSlider.resize();
            //this.signupSlider.update();
          } else {
            if (this.formApplicantEmployment.controls[index]['controls'].previousEmploymentItem.length == 0) {
              //this.addPreviousEmployment();
              this.formApplicantEmployment.controls[index]['controls'].previousEmploymentItem.push(this.initaddPrimaryEmployment())
              //this.signupSlider.resize();
              //this.signupSlider.update();
            }
          }
        }

      }
    }
  }

  changeincomedate(event) {
    var getDate = event.target.value;
    if(this.currentdatestatus) {
      this.valueChange.emit(getDate);
      this.currentdatestatus = false;
    }
  }

  removePreviousEmployment(key) {
    if (key > -1) {
      for (var i = this.formPrimaryEmployment.length; i > 0; i--) {
        if (i > key) {
          this.formPrimaryEmployment.removeAt(i);
        }
      }
    } else {
      this.formPrimaryEmployment.removeAt(key);
    }
  }
  removeAllPreviousEmployment() {
    while (this.formPrimaryEmployment.length !== 0) {
          this.formPrimaryEmployment.removeAt(0);
    }
  }

  addPreviousEmployment() {
    this.formPrimaryEmployment.push(this.initaddPrimaryEmployment());
    this.indexx = this.formPrimaryEmployment.length - 1;
  }

  initaddPrimaryEmployment() {
    // return this.formBuilder.group({
    //   // list all your form controls here, which belongs to your form array
    //   employementType: ['', Validators.compose([Validators.maxLength(30), Validators.required])],
    //   currentlyEmployment: ['', Validators.compose([Validators.maxLength(30)])],
    //   statusyourEmployment: ['', Validators.compose([Validators.maxLength(30), Validators.required])],
    //   your_occupation: ['', Validators.compose([Validators.maxLength(30), Validators.required])],
    //   start_date: ['', Validators.compose([Validators.maxLength(30), Validators.required])],
    //   expectFindWork: ['', Validators.compose([Validators.maxLength(30), Validators.required])],
    //   business_name: ['', Validators.compose([Validators.maxLength(30), Validators.required])],
    //   type_of_entity: [''],
    //   abn_acn: ['', Validators.compose([Validators.maxLength(30)])],
    //   nature_of_business: ['', Validators.compose([Validators.maxLength(30)])],
    //   deleted: [0]
    // });
    return this.formBuilder.group({
      // list all your form controls here, which belongs to your form array
      employementType: ['', Validators.compose([Validators.maxLength(30), Validators.required])],
      currentlyEmployment: ['', Validators.compose([Validators.maxLength(30), Validators.required])],
      statusyourEmployment: ['', Validators.compose([Validators.maxLength(30), Validators.required])],
      your_occupation: ['', Validators.compose([Validators.maxLength(30), Validators.required])],
      start_date: ['', Validators.compose([Validators.maxLength(30), Validators.required])],
      expectFindWork: ['', Validators.compose([Validators.maxLength(30)])],
      business_name: ['', Validators.compose([Validators.maxLength(30), Validators.required])],
      type_of_entity: [''],
      abn_acn: ['', Validators.compose([Validators.maxLength(30)])],
      nature_of_business: ['', Validators.compose([Validators.maxLength(30), Validators.required])],
      deleted: [0]
    });
  }

  public expectedFindWork(value) {
    if (value == 'other') {
      this.expectedWork = 'other';
    } else {
      this.expectedWork = '';
    }
    //this.signupSlider.resize();
    //this.signupSlider.update();
  }

  changeEmploymentTypePrev($event, index){

    debugger;
    let gcurrentlyEmployment = this.slideThreeForm.controls.addPrimaryEmploymentItem['controls'][index].get('currentlyEmployment');
    let gexpectFindWork = this.slideThreeForm.controls.addPrimaryEmploymentItem['controls'][index].get('expectFindWork');
    let gstatusyourEmployment = this.slideThreeForm.controls.addPrimaryEmploymentItem['controls'][index].get('statusyourEmployment');
    let gyour_occupation = this.slideThreeForm.controls.addPrimaryEmploymentItem['controls'][index].get('your_occupation');
    let gstart_date = this.slideThreeForm.controls.addPrimaryEmploymentItem['controls'][index].get('start_date');
    let gbusiness_name = this.slideThreeForm.controls.addPrimaryEmploymentItem['controls'][index].get('business_name');
    let gnature_of_business = this.slideThreeForm.controls.addPrimaryEmploymentItem['controls'][index].get('nature_of_business');
    if($event == 'payg'){
      gcurrentlyEmployment.setValidators(null);
      gexpectFindWork.setValidators(null);
      gbusiness_name.setValidators(null);
      gnature_of_business.setValidators(null);
      gcurrentlyEmployment.setValidators(null);
      gexpectFindWork.setValidators(null);
      gstatusyourEmployment.setValidators([Validators.required])
      gstatusyourEmployment.updateValueAndValidity()

      gyour_occupation.setValidators([Validators.required])
      gyour_occupation.updateValueAndValidity()

      gstart_date.setValidators([Validators.required])
      gstart_date.updateValueAndValidity()
    }
    else if($event == 'self-employed'){
      gcurrentlyEmployment.setValidators(null);
      gexpectFindWork.setValidators(null);
      gstatusyourEmployment.setValidators(null);
      gyour_occupation.setValidators(null);
      gstart_date.setValidators(null);
      // gbusiness_name.setValidators(null);
      // gnature_of_business.setValidators(null);
      this.removePreviousEmployment(index);

      gbusiness_name.setValidators([Validators.required])
      gbusiness_name.updateValueAndValidity()

      gnature_of_business.setValidators([Validators.required])
      gnature_of_business.updateValueAndValidity()

    }
    else if($event == 'unemployed'){
      gcurrentlyEmployment.setValidators(null);
      gexpectFindWork.setValidators(null);
      gstatusyourEmployment.setValidators(null);
      gyour_occupation.setValidators(null);
      gstart_date.setValidators(null);
      gbusiness_name.setValidators(null);
      gnature_of_business.setValidators(null);
      this.removePreviousEmployment(index);

    }else{

      gcurrentlyEmployment.setValidators(null);
      gexpectFindWork.setValidators(null);
      gstatusyourEmployment.setValidators(null);
      gyour_occupation.setValidators(null);
      gstart_date.setValidators(null);
      gbusiness_name.setValidators(Validators.required);
      gnature_of_business.setValidators(Validators.required);
    }

    gcurrentlyEmployment.updateValueAndValidity();
    gexpectFindWork.updateValueAndValidity();
    gstatusyourEmployment.updateValueAndValidity();
    gyour_occupation.updateValueAndValidity();
    gstart_date.updateValueAndValidity();
    gbusiness_name.updateValueAndValidity();
    gnature_of_business.updateValueAndValidity();

    console.log(this.slideThreeForm);


  }

  currentEmployeedPrev(value, index) {
    let gexpectFindWork = this.slideThreeForm.controls.addPrimaryEmploymentItem['controls'][index].get('expectFindWork');
    let gstatusyourEmployment = this.slideThreeForm.controls.addPrimaryEmploymentItem['controls'][index].get('statusyourEmployment');
    let gyour_occupation = this.slideThreeForm.controls.addPrimaryEmploymentItem['controls'][index].get('your_occupation');
    let gstart_date = this.slideThreeForm.controls.addPrimaryEmploymentItem['controls'][index].get('start_date');
    let gbusiness_name = this.slideThreeForm.controls.addPrimaryEmploymentItem['controls'][index].get('business_name');
    let gnature_of_business = this.slideThreeForm.controls.addPrimaryEmploymentItem['controls'][index].get('nature_of_business');
    if (value == 'yes') {
      //this.isCurrentEmployeed = value;
      gstatusyourEmployment.setValidators(Validators.required);
      gyour_occupation.setValidators(Validators.required);
      gstart_date.setValidators(Validators.required);
      gexpectFindWork.setValidators(null);

    } else {
      //this.isCurrentEmployeed = value;
      gexpectFindWork.setValidators(Validators.required);
      gstatusyourEmployment.setValidators(null);
      gyour_occupation.setValidators(null);
      gstart_date.setValidators(null);
    }
    gbusiness_name.setValidators(null);
    gnature_of_business.setValidators(null);

    gexpectFindWork.updateValueAndValidity();
    gstatusyourEmployment.updateValueAndValidity();
    gyour_occupation.updateValueAndValidity();
    gstart_date.updateValueAndValidity();
    gbusiness_name.updateValueAndValidity();
    gnature_of_business.updateValueAndValidity();
    //this.signupSlider.resize();
    //this.signupSlider.update();
  }

  getValue() {
    //this.additionalForm.get
    console.log(this.slideThreeForm.value);
    //console.log(this.formArrApplicantAddress.controls.city.value;
    this.valueChange.emit(this.slideThreeForm.value);

  }



}




// WEBPACK FOOTER //
// ./src/pages/edit-contact-form-list/component/employment-and-incomedetails/employment-details/employment_details.ts